'use client';

import { Dialog } from '@pixum/web-dialog';
import { getMinFileSize } from '@pixum/image-file-validation-service/lib/image-size/get-min-file-size';
import { DIALOG_STYLE, UPLOAD_ERROR_IMAGE_URL } from '../../../../constants';
import { openImageUploadPicker } from '../../../../utils';
import type { UploadErrorBaseProps } from '../../../../types';
import { UploadErrorDialogContent } from '../UploadErrorDialogContent';
import styles from '../upload-error-dialog.module.css';
import { UploadErrorNoUploadReupload } from '../UploadErrorNoUploadReupload';
import { replacePlaceholderContent } from '../../utils/replacePlaceholderContent';

export function UploadErrorFileTooSmall({
  onClose,
  uploadErrors,
  uploadErrorStateActions,
  imageStateActions,
  constants,
  numOfFilesToBeUploaded
}: UploadErrorBaseProps) {
  const uuids = uploadErrors.map(e => e.uuid);
  const files = uploadErrors.map(e => e.file);
  const firstFileName = uploadErrors[0]?.file.name ?? '';

  const handleClose = () => {
    uploadErrorStateActions.removeUploadErrors(uuids);
    imageStateActions.removeImages(uuids);
    onClose?.();
  };

  const handleReupload = () => {
    uploadErrorStateActions.removeUploadErrors(uuids);
    imageStateActions.removeImages(uuids);
    onClose?.();
    openImageUploadPicker();
  };

  const isMultiple = files.length > 1;
  const title = constants['i18n_upload_error_file_size_too_small_title'] ?? '';
  const titleMultiple = constants['i18n_upload_error_file_size_too_small_title_multiple'];
  const minSizeKb = String(getMinFileSize() / 1000);
  const contentText = replacePlaceholderContent(constants['i18n_upload_error_file_size_too_small_content'], {
    '%filename%': firstFileName,
    '%minSize%': minSizeKb
  });
  const contentTextMultiple = replacePlaceholderContent(
    constants['i18n_upload_error_file_size_too_small_content_multiple'],
    { '%numErrorFiles%': String(uploadErrors.length), '%numUploadFiles%': String(numOfFilesToBeUploaded), '%minSize%': minSizeKb }
  );
  const affectedFilesLabel = replacePlaceholderContent(constants['i18n_upload_affected_images'], {
    '%numErrorFiles%': String(uploadErrors.length)
  });

  return (
    <Dialog
      open
      className={styles.dialog}
      onClose={handleClose}
      showCloseButton={false}
      style={DIALOG_STYLE}
      content={
        <UploadErrorDialogContent
          imageUrl={UPLOAD_ERROR_IMAGE_URL.FILE_TOO_SMALL}
          title={title}
          titleMultiple={titleMultiple}
          contentText={contentText}
          contentTextMultiple={contentTextMultiple}
          files={files}
          showFileList={isMultiple}
          affectedFilesLabel={affectedFilesLabel}
        />
      }
      footer={
        <UploadErrorNoUploadReupload constants={constants} onDontUpload={handleClose} onReupload={handleReupload} />
      }
    />
  );
}
